import { Pipe, PipeTransform } from '@angular/core';
import { Process, ScoreCondition } from '../models/process.model';

@Pipe({
  name: 'evaluationScoreMessage',
})
export class EvaluationScoreMessagePipe implements PipeTransform {
  constructor() {
  }

  transform(value: number, process: Process): ScoreCondition {
    const scoreCondition = process?.scoreConditions?.find(q =>
      (q.lessThan && !q.greaterThan && value <= q.lessThan) ||
      (!q.lessThan && q.greaterThan && value >= q.greaterThan) ||
      (q.lessThan && q.greaterThan && value <= q.lessThan && value > q.greaterThan)
    );
    return scoreCondition;
  }
}
